import { makePreloadSlot } from '../../UnicronApp/preloader/PreloadSlot';
import { FlagrFlag } from '../../common/services/FlagrService/types';

export const FlagrSnapshotSlot = makePreloadSlot('FLAGR_SNAPSHOTS_CACHE', (): FlagrFlag[] => []);
